import '../css/CustomerInfo.css'

import { Col, Row, Space } from 'antd'

interface Client {
    id: string // 客户标识
    customer_name: string // 姓名
    customer_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
    service_left_days: number // 剩余天数
    service_address: string // 服务地址
}

interface Prop {
    data?: Client,
    status: string,
    onChange?: () => void
}

export default function (props: Prop) {

    return (<div className="modules">
        {/* 月嫂中心 -> 到府客户管理 -> 客户详情 -> 客户信息 */}
        <div className="top clear" style={{ marginBottom: 20 }}>
            <h3 className="fl">
                <span className="fl">客户信息</span>
                <span className="fl waitstatus">{props.status}</span>
            </h3>
        </div>

        <div className="content" >
            <Row style={{ width: '100%', marginTop: 15 }}>
                <Col span={6} >
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>客人姓名：</p>
                            <p className="right-text">{props.data?.customer_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>手机号码：</p>
                            <p className="right-text">{props.data?.customer_phone || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>服务地址：</p>
                            <p className="right-text" style={{ width: 520 }}>{props.data?.service_address || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>怀孕时期：</p>
                            <p className="right-text">{props.data?.preg_status_desc || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预产期：</p>
                            <p className="right-text">{props.data?.expect_born_day || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>服务开始日期：</p>
                            <p className="right-text">{props.data?.service_start_date || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>服务结束日期：</p>
                            <p className="right-text">{props.data?.service_end_date || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>服务天数：</p>
                            <p className="right-text">{props.data?.service_days || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>剩余天数：</p>
                            <p className="right-text">{props.data?.service_left_days || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    </div>)
}